export default class FormacaoDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, FormacaoService, Formacao, Instituicao, Investigador) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.FormacaoService = FormacaoService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Formacao = Formacao;
    this.Instituicao = Instituicao;
    this.Investigador = Investigador;

    this.showEstadosPanel = false;

    this.loaded = false;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Formacao.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'instituicao', 'investigador']
      }
    }).$promise.then(res => {
      this.data = res;

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.formacao.list');
      this.UI.addToast('Erro ao carregar formação. Verifique a ligação');
    });

  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.Instituicao.find({}).$promise.then(instituicoes => {
        wait.close();
        let options = {
          size: 'lg',
          template: require('./details.dialog.html'),
          controller: ['$scope', ($scope) => {
            $scope.label = "Editar Formação";
            $scope.isNew = false; // Do not show observacoes when editing
            $scope.formacao = angular.copy(this.data);
            $scope.instituicoes = instituicoes;
            $scope.investigadores = investigadores;
            $scope.simnao = this.simnao;

            $scope.dateOptions = {
              dataInicio: {format: 'DD/MM/YYYY'},
              dataFim: {format: 'DD/MM/YYYY'}
            };

            $scope.auxInstituicao = {
              selected: $scope.formacao.instituicao ? $scope.formacao.instituicao : null,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };
            $scope.auxInvestigador = {
              selected: $scope.formacao.investigador ? $scope.formacao.investigador : null,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };
            $scope.auxComunicacao = {
              selected: $scope.formacao.comunicacaoCiencia ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };

            // Infinite Scroll magic
            $scope.addMoreItems = (infiniteScroll) => {
              infiniteScroll.currentItems += infiniteScroll.numToAdd;
            };

            $scope.ok = () => {
              $scope.$close($scope);
            };

            $scope.cancel = () => $scope.$dismiss('cancel');
          }]
        };

        this.UI.showDialog(options).then(res => {
          this.loaded = false;
          if (res) {
            this.data.designacao = res.formacao.designacao;
            this.data.descricao = res.formacao.descricao;
            this.data.horas = res.formacao.horas;

            this.data.dataInicio = res.formacao.dataInicio.format();
            this.data.dataFim = res.formacao.dataFim.format();

            this.data.comunicacaoCiencia = res.auxComunicacao.selected.value;

            this.data.instituicao = res.auxInstituicao.selected;
            this.data.instituicaoId = res.auxInstituicao.selected.id;
            this.data.investigador = res.auxInvestigador.selected;
            this.data.investigadorId = res.auxInvestigador.selected.id;

            this.data.atualizadoPorId = this.user.id;
            this.data.atualizadoa = moment().format();

            this.Formacao.upsert(this.data).$promise.then((res) => {
              this.UI.addToast("Dados atualizados com sucesso");
              this.loadData();
            }).catch((error) => {
              console.log(error);
              this.UI.showAlert("Erro ao atualizar formação. Verifique a ligação");
              this.loaded = true;
            });
          }
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Instituições. Verifique a ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Investigadores. Verifique a ligação");
    });
  };

  editObservacoes = () => {
    let options = {
      size: 'lg',
      template: require('./observacoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Observações";
        $scope.observacoes = angular.copy(this.data.observacoes);

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;
      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();

      this.Formacao.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Observações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar formação. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.FormacaoService.canRead('formacaoRead', true, 'formacaoReadAny', this.FormacaoService.getInvestigadorUserId(this.data));
  canEditGeneral = () => this.FormacaoService.canEdit('formacaoEdit', true, 'formacaoEditAny', this.FormacaoService.getInvestigadorUserId(this.data));

  canReadAdicional = () => this.FormacaoService.canRead('formacaoReadAdicional', true, 'formacaoReadAdicionalAny', this.FormacaoService.getInvestigadorUserId(this.data));
  canEditAdicional = () => this.FormacaoService.canEdit('formacaoEditAdicional', true, 'formacaoEditAdicionalAny', this.FormacaoService.getInvestigadorUserId(this.data));

}

FormacaoDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'FormacaoService', 'Formacao', 'Instituicao', 'Investigador'];
